"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useOnScreen = ref => {
  const [isIntersecting, setIntersecting] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const element = ref === null || ref === void 0 ? void 0 : ref.current;
    if (!element) return;
    const observer = new IntersectionObserver(_ref => {
      let [entry] = _ref;
      setIntersecting(entry.isIntersecting);
    });
    if (element) {
      observer.observe(element);
    }
    return () => {
      observer.unobserve(element);
    };
  }, [ref]);
  return isIntersecting;
};
var _default = exports.default = useOnScreen;